export default "__VITE_ASSET__3St4jGm$__"